import { fork, take, call, put } from "redux-saga/effects";
import types from "./types";
import { apiDirect, postAPIWithoutModule } from "../../api/generic";
import { getGlobalSearchLPResponse, getLPsWithSubscriptionResponse, getMyOBLPListingResp, getNONOBLPListingResp, getNonMyOBLPListingResp, getOBLPListingResp, getSurveyResponse, showSurveyResponse, showTemplateResponse, submitSurveyResponse } from "./actions";

export function* doGetOBLPListing() {
    while (true) {
        const { payload } = yield take(types.GET_OBLP_LISTING)
        const response = yield call(apiDirect, payload)
        yield put(getOBLPListingResp(response))
    }
}

export function* doGetNonOBLPListing() {
    while (true) {
        console.log('GET NON OBLP LIST')
        const { payload } = yield take(types.GET_NON_OBLP_LISTING)
        console.log(payload)
        const response = yield call(apiDirect, payload)
        yield put(getNONOBLPListingResp(response))
    }
}

export function* doGetMyOBLPListing() {
    while (true) {
        const { payload } = yield take(types.GET_MY_OBLP_LISTING)
        const response = yield call(apiDirect, payload)
        yield put(getMyOBLPListingResp(response))
    }
}

export function* doGetMyNonOBLPListing() {
    while (true) {
        const { payload } = yield take(types.GET_NON_MY_OBLP_LISTING)
        const response = yield call(apiDirect, payload)
        yield put(getNonMyOBLPListingResp(response))
    }
}

export function* doGetGlobalSearchLP() {
    while (true) {
        const { payload } = yield take(types.GLOBAL_SEARCH_LP)
        const response = yield call(postAPIWithoutModule, payload)
        yield put(getGlobalSearchLPResponse(response))
    }
}

export function* doGetLpIncludedWithSubscription() {
    while (true) {
        const { payload } = yield take(types.LP_INCLUDED_WITH_SUBSCRIPTION)
        const response = yield call(postAPIWithoutModule, payload)
        yield put(getLPsWithSubscriptionResponse(response))
    }
}
export function* doGetSurveyListing() {
    while (true) {
        const { payload } = yield take(types.GET_SURVEY)
        const response = yield call(postAPIWithoutModule, payload)
        yield put(getSurveyResponse(response))
    }
}
export function* doShowSurveyListing() {
    while (true) {
        const { payload } = yield take(types.SHOW_SURVEY)
        const response = yield call(postAPIWithoutModule, payload)
        yield put(showSurveyResponse(response))
    }
}
export function* doSubmitSurveyListing() {
    while (true) {
        const { payload } = yield take(types.SUBMIT_SURVEY)
        const response = yield call(postAPIWithoutModule, payload)
        yield put(submitSurveyResponse(response))
    }
}

export function* doShowTemplateListing() {
    while (true) {
        const { payload } = yield take(types.SHOW_TEMPLATE)
        const response = yield call(postAPIWithoutModule, payload)
        yield put(showTemplateResponse(response))
    }
}

function* getRes() {
    yield fork(doGetOBLPListing)
    yield fork(doGetNonOBLPListing)
    yield fork(doGetMyOBLPListing)
    yield fork(doGetMyNonOBLPListing)
    yield fork(doGetGlobalSearchLP)
    yield fork(doGetLpIncludedWithSubscription)
    yield fork(doGetSurveyListing)
    yield fork(doShowSurveyListing)
    yield fork(doSubmitSurveyListing)
    yield fork(doShowTemplateListing)
}

export default getRes;